var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgAddressBook = function SvgAddressBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#address-book_svg__clip0_1189_25971)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.25 24H3.75A2.752 2.752 0 011 21.25V2.75A2.752 2.752 0 013.75 0h15.5a.75.75 0 01.75.75V4h1.25a.75.75 0 01.75.75v18.5a.75.75 0 01-.75.75zM2.5 5.199V21.25c0 .689.56 1.25 1.25 1.25H20.5v-17H3.75c-.45 0-.876-.108-1.25-.301zM3.75 1.5c-.69 0-1.25.561-1.25 1.25S3.06 4 3.75 4H18.5V1.5H3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 19.001a.756.756 0 01-.393-.11L9 17.131 6.145 18.89A.752.752 0 015 18.251v-13.5h1.5V16.91l2.106-1.296a.753.753 0 01.787 0L11.5 16.91V4.751H13v13.5a.75.75 0 01-.75.75z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "address-book_svg__clip0_1189_25971"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};

export default SvgAddressBook;